import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { CAMPAIGN_NAMES } from 'constants/personalizations';
import HomepageContainer from 'containers/HomepageContainer';
import * as actions from 'state/actions';
import Iterable from 'utils/Iterable';
import { CONSENT_LIST_STATUS } from 'utils/Iterable/constants';
import Log from 'utils/Log';

const HomepageController = class {
  static get windowData() {
    const data = get(window, ['ALLBIRDS', 'homepage']);

    if (!data) {
      Log.warn('Controllers:HomepageController.windowData -- missing window data!');
    }

    return { data };
  }

  static mountHomepageContainer = store => {
    ReactDOM.render(
      <Provider store={store}>
        <HomepageContainer homepageData={HomepageController.windowData.data} />
      </Provider>,
      document.getElementById('page-home')
    );
  };

  static fetchDyCampaigns = store => {
    store.dispatch(
      actions.fetchPersonalizations({
        names: [CAMPAIGN_NAMES.HP_DESKTOP_MINI_NAV_PLACEMENT],
      })
    );
  };

  static handleBeneluxIterableConsent = async store => {
    const urlParams = new URLSearchParams(window.location.search);
    const emailQueryParam = urlParams.get('email');
    const hasConsentedQueryParam = urlParams.get('hasConsented');

    if (!emailQueryParam || !hasConsentedQueryParam) return;

    const decision =
      hasConsentedQueryParam.toLowerCase() === 'true'
        ? CONSENT_LIST_STATUS.ACCEPTED
        : CONSENT_LIST_STATUS.DECLINED;

    try {
      await Iterable.handleBeneluxConsent(emailQueryParam, decision);
      store.dispatch(actions.openConsentConfirmationModal(decision));
    } catch (error) {
      store.dispatch(actions.openConsentConfirmationModal(CONSENT_LIST_STATUS.ERROR));
    }
  };

  static init = async store => {
    HomepageController.mountHomepageContainer(store);
    HomepageController.fetchDyCampaigns(store);
    HomepageController.handleBeneluxIterableConsent(store);
  };
};

export default HomepageController;
